import { Button, Form, Input } from 'antd';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthHeader } from '../components/AuthHeader';
import { CheckCircleOutlined, IdcardOutlined } from '../icons';
import { ApiError } from '../lib/http';
import { login } from '../services/auth';
import { homePath, setSession } from '../stores/session';

export function LoginPage() {
  const nav = useNavigate();
  const [principal, setPrincipal] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const disabled = !principal.trim() || !password;

  return (
    <div className="auth-page">
      <AuthHeader />
      <main className="auth-main">
        <section className="auth-intro">
          <p className="auth-kicker">成都市第二十中学校 · 高中教育技术保障中心</p>
          <h1>实验室预约与开放课程</h1>
          <p>面向本校高中学生开放。登录后可查看实验室、提交实验申请、报名开放课并查看审核结果。</p>
          <ul className="auth-points">
            <li>
              <CheckCircleOutlined /> 新账号使用 G＋身份证号码注册
            </li>
            <li>
              <CheckCircleOutlined /> 学生、教师均需实验员审核
            </li>
            <li>
              <CheckCircleOutlined /> 原学号、工号账号仍可正常登录
            </li>
          </ul>
        </section>

        <div className="login-card auth-card">
          <h1>账号登录</h1>
          <p className="auth-subtitle">请输入已审核通过的账号</p>
          <Form layout="vertical">
            <Form.Item
              label="账号"
              extra="新账号为 G＋身份证号码；原学号、工号仍可使用"
              validateStatus={error ? 'error' : undefined}
              help={error || undefined}
            >
              <Input
                prefix={<IdcardOutlined />}
                value={principal}
                onChange={(e) => {
                  setPrincipal(e.target.value);
                  setError('');
                }}
                autoComplete="username"
                placeholder="G＋身份证号码 / 学号 / 工号"
              />
            </Form.Item>
            <Form.Item label="密码">
              <Input.Password
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setError('');
                }}
                autoComplete="current-password"
                onPressEnter={() => {
                  if (!disabled && !loading) document.getElementById('login-submit')?.click();
                }}
              />
            </Form.Item>
            <Button
              id="login-submit"
              type="primary"
              htmlType="submit"
              block
              className="touch"
              disabled={disabled}
              loading={loading}
              onClick={async () => {
                setLoading(true);
                try {
                  const data = await login({ principal: principal.trim(), password });
                  const token = data.access_token ?? data.token;
                  if (!token) throw new ApiError('登录响应缺少令牌', 50000, 500);
                  // 强制改密标记在 user 内（守卫用）与顶层（兼容旧响应）都取一次。
                  const mustChange = data.user.must_change_password ?? data.must_change_password ?? false;
                  setSession({ token, user: { ...data.user, must_change_password: mustChange } });
                  if (mustChange) {
                    nav('/change-password', { replace: true });
                    return;
                  }
                  nav(homePath(data.user.role, false), { replace: true });
                } catch (e) {
                  if (e instanceof ApiError && e.code === 42902) setError('尝试过多，请稍后');
                  else if (e instanceof ApiError && e.httpStatus === 401)
                    setError('账号或密码不正确，或注册尚未审核通过');
                  else setError('登录失败，请稍后重试');
                } finally {
                  setLoading(false);
                }
              }}
            >
              登录
            </Button>
          </Form>
          <div className="auth-divider">
            <span>首次使用</span>
          </div>
          <Button block className="touch" onClick={() => nav('/register')}>
            注册账号
          </Button>
          <div className="auth-links">
            <Link to="/register">查询审核状态</Link>
            <Link to="/">返回首页</Link>
          </div>
          <p className="auth-footnote">成都市第二十中学校 · 四川省成都市金牛区育英路6号</p>
        </div>
      </main>
    </div>
  );
}
